import { ReactNodeViewRenderer } from "@tiptap/react"
import { TextSelection } from "@tiptap/pm/state"

import {
  Audio,
  Button,
  Cite,
  CustomDetails,
  CustomDetailsContent,
  CustomDetailsSummary,
  Dd,
  Dfn,
  Div,
  DivInline,
  EnhancedBulletList,
  EnhancedCodeBlockLowlight,
  EnhancedListItem,
  EnhancedOrderedList,
  EnhancedParagraph,
  EnhancedTableHeader,
  EnhancedTableKit,
  EnhancedTableRow,
  EnhancedTextStyleKit,
  EnhancedYoutube,
  Figure,
  Footer,
  Iframe,
  Input,
  Ins,
  Kbd,
  Label,
  Option,
  Select,
  Span,
  TableCellWithBorders,
  TableWithStyles,
  Video,
  lowlight,
} from "@/tiptap/extensions/html-preservation-extensions"
import { CodeBlockNodeView } from "@/tiptap/nodes/code-block-node/code-block-node"

export function createHuduCodeBlockExtension() {
  return EnhancedCodeBlockLowlight.extend({
    addKeyboardShortcuts() {
      return {
        ...this.parent?.(),
        "Mod-a": ({ editor }) => {
          const { state, view } = editor
          const { selection } = state
          const { $from } = selection

          let codeBlockPos = null
          let codeBlockNode = null

          for (let depth = $from.depth; depth >= 0; depth--) {
            const nodeAtDepth = $from.node(depth)
            if (nodeAtDepth.type === this.type) {
              codeBlockNode = nodeAtDepth
              codeBlockPos = depth === 0 ? 0 : $from.before(depth)
              break
            }
          }

          if (!codeBlockNode || codeBlockPos == null || codeBlockNode.content.size === 0) {
            return false
          }

          const start = codeBlockPos + 1
          const end = codeBlockPos + codeBlockNode.nodeSize - 1

          view.dispatch(state.tr.setSelection(TextSelection.create(state.doc, start, end)))

          return true
        },
      }
    },

    addNodeView() {
      return ReactNodeViewRenderer(CodeBlockNodeView)
    },
  }).configure({
    lowlight,
    enableTabIndentation: true,
    tabSize: 2,
    languageClassPrefix: "language-",
    defaultLanguage: null,
    HTMLAttributes: {
      style: null,
      class: null,
    },
  })
}

export function getHuduSharedExtensions({ tableOptions } = {}) {
  return [
    EnhancedParagraph,
    Div,
    DivInline,
    Footer,
    Figure,
    Dd,
    Span,
    Cite,
    Dfn,
    Ins,
    Kbd,
    Label,
    EnhancedListItem,
    EnhancedOrderedList,
    EnhancedBulletList,
    EnhancedYoutube,
    Iframe,
    Audio,
    Video,
    Input,
    Button,
    Option,
    Select,
    createHuduCodeBlockExtension(),
    EnhancedTableKit,
    TableWithStyles.configure(tableOptions || {}),
    EnhancedTableRow,
    EnhancedTableHeader,
    TableCellWithBorders,
    EnhancedTextStyleKit,
    CustomDetails,
    CustomDetailsSummary,
    CustomDetailsContent,
  ]
}

export {
  EnhancedBulletList,
  EnhancedListItem,
  EnhancedOrderedList,
  EnhancedParagraph,
  EnhancedTableHeader,
  EnhancedTableKit,
  EnhancedTableRow,
  EnhancedTextStyleKit,
  EnhancedYoutube,
  TableCellWithBorders,
  TableWithStyles,
  lowlight,
}
